var exports = {
  "kL": "BottomCTASection.module__container___TkV4QX",
  "DD": "BottomCTASection.module__title___TkV4QX",
  "UD": "BottomCTASection.module__buttonContainer___TkV4QX",
  "x6": "BottomCTASection.module__button___TkV4QX",
};

module.exports = exports;
